import { TenantForSidebarDto } from './tenantsModel'

export type TenantOption = {
  value: number
  label: string
}

export type TenantOptionFilter = {
  activeOnly?: boolean
  alwaysInclude?: number[]
}

export const toTenantOptions = (
  tenants: TenantForSidebarDto[],
  filter: TenantOptionFilter = {}
): TenantOption[] => {
  const alwaysInclude = filter.alwaysInclude ?? []
  return [...tenants]
    .filter(tenant => !filter.activeOnly || tenant.active || alwaysInclude.includes(tenant.id))
    .sort((a, b) => a.name.localeCompare(b.name))
    .map(tenant => ({
      value: tenant.id,
      label: tenant.active ? `${tenant.name} (${tenant.id})` : `${tenant.name} (${tenant.id}) — inactive`,
    }))
}

export const filterTenantOption = (input: string, option?: TenantOption): boolean => {
  return (option?.label ?? '').toLowerCase().includes(input.trim().toLowerCase())
}
